import $axios from '../api.js'

const state = () => ({
    sender: [],
    auth_data: {
        name: '',
        phone: '',
        referred_by: '',
        verification_code: '',
    },
    loading: {
        button: false,
        screen: false
    }
})

const mutations = {
    SET_SENDER(state, payload){
        state.sender = payload
    },
    RESET_AUTH_DATA(state) {
        state.auth_data = {
            name: '',
            phone: '',
            verification_code: '',
            referred_by: '',
        }
    },
    RESET_LOADING(state){
        state.loading = {
            button: false,
            screen: false
        }
    },
    RESET_TOAST(state){
        state.toast = {
            show: false,
            message: 'Success',
            tipe: 'default',
            top:'',
            position: 'top'
        }
    }
}

const actions = {
    getSender({commit}){
        return new Promise((resolve,reject) => {
            $axios.get('/auth/sender')
            .then((response) => {
                commit('SET_SENDER', response.data.data)
                resolve(response.data)
            }).catch((error) => {
                reject(error.response)
            })
        })
    },
    register({state}){
        return new Promise((resolve,reject) => {
            $axios.post('/auth/register', state.auth_data)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error.response)
            })
        })
    },
    login({state}){
        return new Promise((resolve,reject) => {
            $axios.post('/auth/login', state.auth_data)
            .then((response) => {
                resolve(response.data)
            }).catch((error) => {
                reject(error.response)
            })
        })
    },
    requestCode({state},payload){
        return new Promise((resolve,reject) => {
            $axios.post('/auth/request-code', {
                sender_id:payload.id,
                phone:payload.phone
            }).then((response) => {
                console.log(state.sender)
                resolve(response.data)
            }).catch((error) => {
                reject(error.response)
            })
        })
    },
    verifyCode({ state,commit }) {
        localStorage.setItem('token', null)
        commit('SET_TOKEN', null, { root: true })
        return new Promise((resolve,reject) => {
            $axios.post('/auth/verify-code', state.auth_data)
            .then((response) => {
                if (response.data.status == true) {
                    localStorage.setItem('token', response.data.access_token)
                    commit('SET_TOKEN', response.data.access_token, { root: true })
                    commit('SET_CUSTOMER', response.data.data, { root: true })
                }
                resolve(response.data)
            }).catch((error) => {
                reject(error.response)
            })
        })
    },
    logout({commit}){
        return new Promise((resolve,reject) => {
            $axios.post('/auth/logout')
            .then((response) => {
                localStorage.removeItem('token')
                commit('SET_TOKEN', null, { root: true })
                resolve(response.data)
            }).catch((error) => {
                reject(error.response)
            })
        })
    }
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}